import { render, staticRenderFns } from "./TrainingCalendar.vue?vue&type=template&id=3b612ffa&scoped=true&"
import script from "./TrainingCalendar.vue?vue&type=script&lang=js&"
export * from "./TrainingCalendar.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCalendar.vue?vue&type=style&index=0&id=3b612ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b612ffa",
  null
  
)

export default component.exports